import { render, staticRenderFns } from "./login.vue?vue&type=template&id=72378418&scoped=true&"
import script from "./login.vue?vue&type=script&lang=ts&"
export * from "./login.vue?vue&type=script&lang=ts&"
import style0 from "./login.vue?vue&type=style&index=0&id=72378418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72378418",
  null
  
)

export default component.exports